(function () {

    // Cache Tabs container and tab data source
    var $tabContainers = $('.jsTabsContainer');

    $tabContainers.each(function(){
    
        var source = this.getAttribute('data-source'),
            $thisTabContainer = $(this);
        

        // Create Tabs menu within container
        var tabsMenu = document.createElement('ul');
        tabsMenu.setAttribute('class','tabs');
        $thisTabContainer.append(tabsMenu);

        $(source + ' h3').each(function (index) {
          
          
            // Get tab content
            // We're setting an arbitrary limit on the while loop just in case something goes wrong that it doesn't loop, and loop, and loop, and loop, and loop.
            var i = 0;
            var step = this;
            var tabContent = [];

            while (i < 100) {
                i++;
                
                var nextStep = $(step)[0].nextElementSibling;

                if (nextStep && $(nextStep)[0].tagName != "H3") 
                {
                    tabContent.push($(nextStep)[0].outerHTML);
                    step = nextStep;
                    continue;
                }
                break;
            }

            //  Set tab content
            var accordion = document.createElement('button');
          	var title = $(this).text();
          	accordion.innerHTML =  title;
          	accordion.setAttribute('class', 'accordion');
          	$thisTabContainer.append(accordion);
          
            var tabPane = document.createElement('div');
            tabPane.innerHTML = tabContent.join('');
          	tabPane.setAttribute('class', 'panel');
            $thisTabContainer.append(tabPane);
        });
    });


    var acc = document.getElementsByClassName("accordion");
  
    var panel = document.getElementsByClassName('panel');
  	panel[0].setAttribute('class', 'panel show')

    for (var i = 0; i < acc.length; i++) {
        acc[i].onclick = function() {
            var setClasses = !this.classList.contains('active');
            setClass(acc, 'active', 'remove');
            setClass(panel, 'show', 'remove');

            if (setClasses) {
                this.classList.toggle("active");
                this.nextElementSibling.classList.toggle("show");
            }
        }
    }

    function setClass(els, className, fnName) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList[fnName](className);
        }
    }
  
})();



